import { callApi } from "@app/api";

export const loadAssignments = (queryParams = "") =>
  callApi(`assignments/${queryParams}`, {
    method: "GET",
  });

export const loadPracticeAssignments = (treatmentId, studentId) =>
  loadAssignments(`?status=0&completed_session=${treatmentId}&student=${studentId}`);

export const saveSelfPractice = (body) =>
  callApi("self_practice/save/", {
    method: "POST",
    type: "JSON",
    body,
  });

export const pullSelfPractice = (treatmentId, studentId) => callApi(`self_practice/get/?treatment_id=${treatmentId}${studentId ? `&student_id=${studentId}` : ""}`, { method: "GET" });
export const pullMultiSelfPractice = (studentId) => callApi(`self_practice/statuses/?student_id=${studentId}`, { method: "GET" });
export const pullStudentSelfPractice = () => callApi("student/self_practice/get/", { method: "GET" });
export const pullGameWords = (body) => callApi("student/self_practice/words/", { method: "POST", body });
export const saveStudentSelfPractice = (body) =>
  callApi("student/self_practice/save/", {
    method: "POST",
    type: "JSON",
    body,
  });

export const studentSelfPracticeUpdate = (body) =>
  callApi("student/self_practice/update_details/", {
    method: "POST",
    type: "JSON",
    body,
  });

export const getPDFAttendance = practiceId => callApi(`self_practice/report/?practice_id=${practiceId}`, {
  method: "GET",
  type: "PDF",
});
